'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var getStyle=function(token){return function(props){var style=props.theme.vstui[token],styleValue='function'==typeof style?style(props):style;return(void 0===styleValue||'string'==typeof styleValue&&(-1!==styleValue.indexOf('undefined')||-1!==styleValue.indexOf('null')||-1!==styleValue.indexOf('NaN')))&&console.log('Token \''+token+'\' does not exist.'),styleValue}};exports.default=getStyle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vitalsource/vstui/themes/getStyle.js
// module id = 557
// module chunks = 162